module.exports = __webpack_public_path__ + "static/anana-vestige-journal-video-cover-a2ca50f2eb71d40756c3849baf979c4a.png";